import React, { useMemo } from 'react';

import adminApiClient from 'api/adminApiClient';
import backofficeApiClient from 'api/backofficeApiClient';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import { FileValue } from 'components/wrappers/BaseFileUpload';
import {
  generateUploadFileList,
  getFileUploadMessages,
  mapS3UploadFilesToDownloadResponseModel,
} from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];

const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

export type AgreementFileValue = FileValue & {
  createdDate: any;
};

type Props = {
  fieldName: string;
  isAdmin?: boolean;
  files?: FileValue[];
  isSimpleUpload?: boolean;
};

export default React.memo((props: Props) => {
  const { fieldName, isAdmin, files = [], isSimpleUpload } = props;

  const defaultFileList = useMemo(() => {
    const mappedFilesToCorrectModel =
      mapS3UploadFilesToDownloadResponseModel(files);

    return files ? generateUploadFileList(mappedFilesToCorrectModel) : [];
  }, [files]);

  const uploadFileLinkFunction = isAdmin
    ? adminApiClient.getCustomerAgreementUploadLink.bind(adminApiClient)
    : backofficeApiClient.getCustomerAgreementUploadLink.bind(
        backofficeApiClient,
      );

  return (
    <FormikFileUpload
      name={fieldName}
      isDraggable
      includeFileName
      defaultFileList={defaultFileList}
      maxFileCount={3}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      uploadLinkFunction={uploadFileLinkFunction}
    >
      {() =>
        isSimpleUpload ? (
          <i className="icon icon-upload" />
        ) : (
          <BaseDraggerContent fileTypes={FILE_TYPES} />
        )
      }
    </FormikFileUpload>
  );
});
